import TagGroupSelect from '-/Custom/TagGroupSelect';
import { useFormContext, useWatch } from 'react-hook-form';
import type { EventEditFormValues } from './EventEdit.types';
export default function EventEditTagGroup() {
  const { tagGroupId } = useWatch<EventEditFormValues>();
  const { setValue } = useFormContext<EventEditFormValues>();
  const onPressTagGroup = (pressedTagGroupId: string) => {
    if (pressedTagGroupId === tagGroupId) {
      setValue('tagGroupId', '', {
        shouldDirty: true,
      });
    } else {
      setValue('tagGroupId', pressedTagGroupId, {
        shouldDirty: true,
      });
    }
  };
  return (
    <TagGroupSelect
      selected={tagGroupId ? [tagGroupId] : []}
      onPress={onPressTagGroup}
    />
  );
}
